import React from "react";

import { IFormProps } from "./interfaces";

import { useSmoothAnchor } from "hooks";
import { Anchor, Container, Primary, Secondary } from "./styles";

const Form: React.FC<IFormProps> = ({
  onSubmit,
  onCancel,
  isLoading,
  ...props
}) => {
  const anchor = useSmoothAnchor();

  return (
    <Container {...props}>
      <Anchor.Button onClick={anchor.handler}>
        <Anchor.Icon name="arrow-up" />
      </Anchor.Button>

      {onCancel && (
        <Secondary to={onCancel.to} onClick={onCancel.onClick}>
          {onCancel.label}
        </Secondary>
      )}

      <Primary
        icon={onSubmit.icon}
        onClick={onSubmit.onClick}
        isLoading={isLoading}
        type="submit"
      >
        {onSubmit.label}
      </Primary>
    </Container>
  );
};

export default Form;
